// projectTypes.ts — Sprint 12. Domain types + filter shape for the
// Projects page. Pure module: no React, no antd, no store.

export type ProjectStatus   = 'PLANNING' | 'IN_PROGRESS' | 'COMPLETED' | 'ON_HOLD' | 'CANCELLED';
export type ProjectPriority = 'LOW' | 'MEDIUM' | 'HIGH' | 'URGENT';

export interface Project {
  id:                   string;
  condoId:              string;
  name:                 string;
  description:          string;
  budget:               number;
  actualCost?:          number;
  responsiblePerson:    string;
  responsiblePersonId?: string;
  startDate:            Date;
  endDate:              Date;
  status:               ProjectStatus;
  priority:             ProjectPriority;
  category:             string;
  documents?:           string[];
  notes?:               string;
  createdAt:            Date;
  updatedAt:            Date;
}

export interface ProjectSummary {
  totalProjects:     number;
  activeProjects:    number;
  completedProjects: number;
  totalBudget:       number;
  totalActualCost:   number;
  budgetVariance:    number;
}

export interface ProjectSearchFilters {
  searchTerm?: string;
  year?:       number;
  status?:     ProjectStatus;
  category?:   string;
  priority?:   ProjectPriority;
  dateRange?:  [Date, Date];
}

export const STATUS_OPTIONS: Array<{ value: ProjectStatus; label: string }> = [
  { value: 'PLANNING',    label: 'Planning'    },
  { value: 'IN_PROGRESS', label: 'In Progress' },
  { value: 'COMPLETED',   label: 'Completed'   },
  { value: 'ON_HOLD',     label: 'On Hold'     },
  { value: 'CANCELLED',   label: 'Cancelled'   },
];

export const PRIORITY_OPTIONS: Array<{ value: ProjectPriority; label: string }> = [
  { value: 'LOW',    label: 'Low'    },
  { value: 'MEDIUM', label: 'Medium' },
  { value: 'HIGH',   label: 'High'   },
  { value: 'URGENT', label: 'Urgent' },
];

export const CATEGORY_OPTIONS: Array<{ value: string; label: string }> = [
  { value: 'renovation',     label: 'Renovation'     },
  { value: 'maintenance',    label: 'Maintenance'    },
  { value: 'infrastructure', label: 'Infrastructure' },
  { value: 'landscaping',    label: 'Landscaping'    },
  { value: 'security',       label: 'Security'       },
  { value: 'other',          label: 'Other'          },
];
